import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShareModule } from '../share/share.module';
import { ScanRoutes } from './scan.routing';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/core/material.module';
import { InfoECouponComponent } from './info-e-coupon/info-e-coupon.component';
import { InfoQuestComponent } from './info-quest/info-quest.component';
import { InfoCampaignComponent } from './info-campaign/info-campaign.component';
import { ScanManagementComponent } from './scan-management/scan-management.component';

@NgModule({
  declarations: [
    InfoECouponComponent,
    InfoQuestComponent,
    InfoCampaignComponent,
    ScanManagementComponent
  ],
  imports: [
    CommonModule,
    ShareModule,
    ScanRoutes,
    ReactiveFormsModule,
    FormsModule,
    MaterialModule,
  ]
})
export class ScanModule { }
